import { render, staticRenderFns } from "./PushParcel.vue?vue&type=template&id=62ff0f22&"
import script from "./PushParcel.vue?vue&type=script&lang=js&"
export * from "./PushParcel.vue?vue&type=script&lang=js&"
import style0 from "./PushParcel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports